import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
    const [scrollPos, setScrollPos] = useState('');

    const handleScroll = () => {
        setScrollPos(window.scrollY);
    }

    const ScrollToWindowTop = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    return (
        <button
            type="button"
            className={`${scrollPos > 50 ? 'block' : 'hidden'} fixed bottom-20 right-10 bg-white p-3 h-12 w-12 border text-center cursor-pointer rounded-md z-20`}
            onClick={ScrollToWindowTop}
        >
            <i className="fa fa-arrow-up" />
        </button>
    );
};

export default ScrollToTop;
